import React, { Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import jwtDecode from "jwt-decode";

import LayoutWrapper from "./components/layoutWrapper";
import Spinner from "./components/spinner";
import { guestRoutes, userRoutes } from "./routes/mainRoutes/mainRoutes";
import { setUserDetailsSuccess } from "store/sagaActions";
import { resetUserDetails } from "store/sagaActions";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { Slide, ToastContainer } from "react-toastify";

function App() {
  const dispatch = useDispatch();

  const { authToken } = useSelector((state) => state?.auth?.otpVerification);

  const token = sessionStorage.getItem("authToken");
  const isAuthenticated = !!token;

  const [routes, setRoutes] = useState([]);

  let mainContent = routes.map((route) =>
    route.component ? (
      <Route
        key={route.name}
        path={route.path}
        exact={route.exact}
        name={route.name}
        element={<route.component />}
      />
    ) : (
      route.redirectRoute && (
        <Route
          path="*"
          key={route.name}
          element={<Navigate key={route.name} to={route.path} />}
        />
      )
    )
  );
  useEffect(() => {
    dispatch(resetUserDetails());
  }, []);

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      dispatch(setUserDetailsSuccess({ data: decoded?.user }));
    }
  }, [token, authToken]);

  useEffect(() => {
    if (isAuthenticated) {
      setRoutes(userRoutes);
    } else {
      setRoutes(guestRoutes);
    }
  }, [isAuthenticated]);

  const renderToastIcon = ({ type }) => {
    const iconMap = {
      success: "✓",
      info: "i",
      warning: "!",
      error: "×",
      default: "•",
    };

    return (
      <span className={`bl-toast-custom-icon bl-toast-custom-icon--${type || "default"}`}>
        {iconMap[type] || iconMap.default}
      </span>
    );
  };

  return (
    <Suspense fallback={<Spinner />}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<LayoutWrapper isAuthenticated={isAuthenticated} />}
          >
            {mainContent}
          </Route>
        </Routes>
        <ToastContainer
          className="bl-toast-container"
          toastClassName="bl-toast"
          bodyClassName="bl-toast-body"
          progressClassName="bl-toast-progress"
          position="top-right"
          autoClose={2800}
          hideProgressBar={false}
          newestOnTop={true}
          icon={renderToastIcon}
          limit={3}
          transition={Slide}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="light"
        />
      </Router>
    </Suspense>
  );
}

export default App;
